import { Logo } from 'components/images/logo'
import { HeaderIcon } from 'components/images/header-icon'
import React from 'react'

import './styles.scss'
import { HeaderComponentProps } from './types'

export const HeaderComponent = (props: HeaderComponentProps) => {
  return (
    <div className="standard-header">
      <div className="icon-container">
        <HeaderIcon
          name={props.icon}
          width={props.iconWidth ? props.iconWidth : 80}
          height={props.iconHeight ? props.iconHeight : 80}/>
      </div>
      <div className="titles-and-description-container">
        <h6 className="title">
          {props.title}
        </h6>
        <div className="sub-title">
          {props.subTitle}
        </div>
        {props.description &&
        <div className="description">
          {props.description.map((d, i) => <p key={i}>{d}</p>)}
        </div>}
      </div>
      <div className="logo-container">
        <Logo/>
      </div>
    </div>
  )
}
